import ComparisonPdfButton from './ComparisonPdfButton'
import comparisonPdfButtonContainer from './comparisonPdfButtonContainer'

export default comparisonPdfButtonContainer(ComparisonPdfButton)
